import React from "react";
import { Layout } from "./src/components/layout";
import { Amplify, Auth } from "aws-amplify";
import { Authenticator, View, useTheme } from "@aws-amplify/ui-react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min";
import "@popperjs/core/dist/umd/popper.min";
import "/static/styles/global.css";
import "@aws-amplify/ui-react/styles.css";
import SwaggerUI from "swagger-ui";
import "swagger-ui-react/swagger-ui.css";
import { Logo } from "./src/components/fa";

const components = {
  Header() {
    const { tokens } = useTheme();

    return (
      <View className="m-5" textAlign="center" padding={tokens.space.large}>
        <div className="text-light">
          <Logo
            className="text-secondary d-inline display-1"
            style={{ width: "100px", height: "75px" }}
            icon="circle-nodes"
          />
          <br />
          <h1 className="d-inline display-3 align-top "> Sensor Network</h1>
        </div>
      </View>
    );
  },
};

export const wrapPageElement = ({ element, props }) => (
  <Authenticator
    components={components}
    socialProviders={["facebook"]}
    hideSignUp={true}
  >
    {({ signOut, user }) => (
      <Layout signOut={signOut} user={user} {...props}>
        {element}
      </Layout>
    )}
  </Authenticator>
);

export const wrapRootElement = ({ element }) => {
  window.SwaggerUI = SwaggerUI;

  const config = {
    Auth: {
      mandatorySignIn: true,
      region: "eu-west-1",
      userPoolId: process.env.GATSBY_POOL_ID,
      userPoolWebClientId: process.env.GATSBY_CLIENT_ID,
      oauth: {
        domain: process.env.GATSBY_AUTH_DOMAIN,
        scope: [
          "phone",
          "email",
          "profile",
          "openid",
          "aws.cognito.signin.user.admin",
        ],
        redirectSignIn: process.env.GATSBY_SITE_URL,
        redirectSignOut: process.env.GATSBY_SITE_URL,
        responseType: "code",
      },
    },
    API: {
      endpoints: [
        {
          name: "exsertus",
          endpoint: process.env.GATSBY_API_URL,
          custom_header: async () => {
            return {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getAccessToken()
                .getJwtToken()}`,
            };
          },
        },
      ],
    },
  };

  Amplify.configure(config);

  return element;
};
